<template>
  <v-card
    :class="{'no-data': topArticoliOggi.length == 0}" v-loading height="260">
    <div v-if="topArticoliOggi.length == 0" class="display-2"> Nessun dato </div>
    <v-list v-else>
      <template
        v-for="(articolo, i) in topArticoliOggi">
        <v-list-tile :key="i">
          <v-list-tile-content>
            <v-list-tile-title primary-title>
              {{i+1}}. <badge-locale
                          v-if="multiMode"
                          :locale="articolo[0]" /> {{ articolo[2] | fixText }}
            </v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            {{ articolo[3] }}
          </v-list-tile-action>
        </v-list-tile>
        <v-divider
          v-if="i+1 < topArticoliOggi.length"
          :key="`d-${i}`"
        ></v-divider>
      </template>
    </v-list>
  </v-card>
</template>

<script>
import stats from '@/mixins/stats';

export default {
  name: 'top-articoli-oggi',
  mixins: [stats],
  methods: {
    async refresh(type = null) {
      if (type === 'SESSION' || type === 'LOCALI') {
        await this.topArticoliOggiReload();
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.no-data
  display flex
  justify-content center
  align-items center
</style>
